export default __webpack_public_path__ + "static/media/thankyoukeyvis_voucher100_dt_roi.8fbf5e8e.png";